import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { Row, Col } from 'react-bootstrap'

import chinaProLogo from '../../assets/chinaProLogo.png'

import Content from '../../components/Content'
import Container from '../../components/Container'

class Services extends Component {
  componentDidMount = () => {
    // const atemtion = document.querySelector('#atemtion')
    // const anchor = document.querySelector('#anchor')
    // atemtion.style.top = `${anchor.offsetTop +
    //   atemtion.clientHeight / 1.5 +
    //   30}px`
    // atemtion.style.left = `${anchor.offsetLeft + atemtion.clientWidth / 2}px`
    // atemtion.style.width = '620px'
  }
  render() {
    const { pages = [] } = this.props
    const content =
      pages.find(({ path }) => path === window.location.pathname) || {}
    const { atemption = {} } = content

    return (
      <Container>
        <StyledRow>
          <Col md={6}>
            <Rectangle className="animated fadeInRight fast">
              <img src={chinaProLogo} alt="" />
            </Rectangle>
          </Col>
          <Col md={6}>
            <Width className="animated fadeInDown fast">
              <Content data={content} />

              <Atemption className="animated delay-1s fadeInLeft">
                {atemption.html ? (
                  <div class="content">{atemption.html}</div>
                ) : (
                  <div class="content">
                    Команда China Pro зарекомендовала себя одним из главных
                    игроков на рынке HoReCa.Многолетний опыт работы, позволяет
                    нам предоставлять вам лучшие и наиболее подходящие вашему
                    дизайн- проекту решения, осуществляя всевозможные задумки.
                  </div>
                )}
              </Atemption>
              {/* <div id="anchor"></div> */}
            </Width>
          </Col>
        </StyledRow>
      </Container>
    )
  }
}

export default connect(state => state)(Services)

const StyledRow = styled(Row)`
  flex-direction: row-reverse;

  @media (max-width: 768px) {
    flex-direction: column-reverse;
  }
`
const Width = styled.div`
  max-width: 800px;
  margin-right: auto;
`
const Rectangle = styled.div`
  /* position: relative; */
  margin-top: 10px;
  width: 100%;
  height: 70vh;
  background: linear-gradient(180deg, #2568e4 0%, #00233a 100%);
  & img {
    max-width: 90%;
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
  }
`

const Atemption = styled.div`
  background-color: #2568e4;
  position: relative;
  width: calc(110%);
  border-radius: 10px;
  padding: 10px 15px;
  margin: 20px 15px;
  /* display: none; */
  z-index: 9999 !important;
  @media (max-width: 768px) {
    display: flex;
    width: calc(100% - 30px);
  }
  .content {
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 28px;
    color: #fff;
    opacity: 0.7;
    transition: all 1s;
  }
`
